import { css } from "@emotion/react";

export const submitButton = css`
  cursor: pointer;
`;
